import WebTabPage from './src/Index.vue';

export default WebTabPage;
